import { AvailableModules } from 'generated/featureDefinitions'

import { ValidReasons } from 'modules/upsell/hooks/useCreateUpsellRequest'
import { UpsellingKit } from 'modules/upselling_kit/components'

interface SalesProductModalProps {
  isOpen: boolean
  onClose: () => void
  requestSource: string
  pageSource: string
}

export const SalesProductModal = ({
  isOpen,
  onClose,
  requestSource,
  pageSource,
}: SalesProductModalProps) => {
  return (
    <UpsellingKit.ProductModal
      moduleRequested={AvailableModules.sales}
      requestSource={requestSource}
      requestReason={ValidReasons.MissingAddon}
      pageSource={pageSource}
      isOpen={isOpen}
      onClose={onClose}
    />
  )
}
